if (!customElements.get('scrolling-text-bar')) {
    customElements.define('scrolling-text-bar', class ScrollingTextBar extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.init();
            this.lastWidth = this.offsetWidth;

            this.observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const newWidth = entry.contentRect.width;
                    if (newWidth !== this.lastWidth) {
                        this.lastWidth = newWidth;
                        this.init();
                    }
                }
            });

            const wrapper = this.querySelector('.scrolling-text-bar');
            if (wrapper) {
                this.observer.observe(wrapper);
            }
        }
        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
        init() {
            const parentContainer = this.querySelector('.scrolling-text-bar');
            const wrapper = this.querySelector('.scrolling-text-bar__wrapper');
            const item = this.querySelector('.scrolling-text-bar__item');

            if (!parentContainer || !wrapper || !item) return;
    
            const baseSpeed = parseFloat(this.dataset.animationSpeed);
            const parentContainerWidth = parentContainer.offsetWidth;
            const itemWidth = item.offsetWidth;
            
            if (itemWidth === 0) return;
            
            const animationSpeedModifier = 4;
            const calculatedDuration = ((itemWidth / baseSpeed)/animationSpeedModifier).toFixed(2);
            
            const children = Array.from(item.children);
            const childrenWidth = children.reduce((acc, child) => acc + child.offsetWidth, 0);
            const itemsCount = Math.ceil(parentContainerWidth / childrenWidth) + 1;
    
            // Clear existing clones if needed
            const existingItems = wrapper.querySelectorAll('.scrolling-text-bar__item');
            if (existingItems.length > 1) {
                existingItems.forEach((el, index) => {
                    if (index > 0) el.remove();
                });
            }
            // Clone the item
            for (let i = 0; i < itemsCount; i++) {
                const clone = item.cloneNode(true);
                wrapper.appendChild(clone);
            }
            
            // Update the animation
            this.style.setProperty('--item-width', `${itemWidth}px`);

            // Update the animation speed so that it is more consistent across devices
            
            this.style.setProperty('--dynamic-duration', `${calculatedDuration}s`);

            //console.log("scrolling text bar updated", itemsCount);
        }
    });
}